"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Icon = require("../Icon/Icon");

var _LinkButton = _interopRequireDefault(require("./LinkButton"));

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    icon: {
      marginRight: 4
    },
    link: {
      display: 'flex',
      alignItems: 'center'
    },
    disabled: {
      pointerEvents: 'none'
    }
  };
});
/**
 * @callback mouseEventCb
 * @param {React.MouseEvent} event
 * @returns {void}
 */

/**
 * FlatButton.
 *
 * @deprecated
 *
 * @param {object} props
 * @param {React.ReactElement | string} [props.children=null]
 * @param {string} [props.icon=undefined]
 * @param {mouseEventCb} props.onClick
 * @param {boolean} [props.disabled=false]
 * @param {string} [props.className='']
 * @returns {React.ReactElement}
 * @example
 * // TODO: Write example
 */

var FlatButton = function FlatButton(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      className = _ref.className;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 1,
    mb: 3,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], {
    className: (0, _classnames["default"])(disabled ? "Body-Regular-Left-Inactive-Bold ".concat(classes.disabled) : 'Body-Regular-Left-Link-Bold', classes.link),
    onClick: onClick,
    disabled: disabled
  }, icon && /*#__PURE__*/_react["default"].createElement(_Icon.DashboardIcon, {
    icon: icon,
    className: classes.icon
  }), children));
};

FlatButton.propTypes = {
  children: _propTypes["default"].node,
  icon: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
FlatButton.defaultProps = {
  children: null,
  icon: undefined,
  disabled: false,
  className: ''
};
var _default = FlatButton;
exports["default"] = _default;